import { useDebounce } from 'use-debounce';

const { VITE_APP_ENERGY_USAGE_QUERIES_DEBOUNCE_MS } = import.meta.env;

const EnergyUsageQueriesDebounceMs = parseInt(
  VITE_APP_ENERGY_USAGE_QUERIES_DEBOUNCE_MS,
);

export function useDebounceValue(value: string) {
  if (!EnergyUsageQueriesDebounceMs) {
    return value;
  }
  return useDebounce(value, EnergyUsageQueriesDebounceMs);
}
